import React, { useEffect, useState } from 'react';
import Link from '../Link/Link';
import Avatar from '../../assets/images/icons/avatar-default.jpg';
import PingLogo from '../../assets/images/Ping-Logo.svg';
import TwitterLogo from '../../assets/images/icons/twitter.svg';
import InstagramLogo from '../../assets/images/icons/instagram.svg';
import Styles from './AuthorInfo.module.scss';

const AuthorInfo = (props) => {
  const { authorInfo } = props;
  const [imgSrc, setImgSrc] = useState(Avatar);
  useEffect(() => {
    setImgSrc(authorInfo?.profileImage ?? Avatar);
  }, [authorInfo]);

  return (
    <div id='authorInfoContainer' className={Styles.authorInfoContainer}>
      {authorInfo
        && (
          <div>
            <div className={Styles.header}>
              <div className={Styles.titleAvatarConatiner}>
                <span><img className={Styles.avatar} src={imgSrc} alt='user-image' onError={() => setImgSrc(Avatar)} /></span>
                <span className={Styles.authorTitles}>
                  <div className={Styles.name}>{authorInfo.name}</div>
                  <div className={Styles.title}>{authorInfo.jobTitle}</div>
                  <div className={Styles.location}>{authorInfo.jobLocation}</div>
                </span>
              </div>
              <div className={Styles.logos}>
                <img src={PingLogo} alt='ping-logo' />
                <div className={Styles.socialMediaLogos}>
                  {authorInfo?.twitter && <a href={authorInfo.twitter} target='__blank'><img src={TwitterLogo} alt='twitter' /></a>}
                  {authorInfo?.instagram && <a href={authorInfo.instagram} target='__blank'><img src={InstagramLogo} alt='instagram' /></a>}
                </div>
              </div>
            </div>
            <div className={Styles.authorBio}>
              {authorInfo.bio}
            </div>
            <div className={Styles.authorLinks}>
              {authorInfo.articles
                && authorInfo.articles.map((article, index) => {
                  return (
                    <span key={index}>
                      <Link article={article} />
                    </span>
                  );
                })
              }
            </div>
          </div>
        )}
    </div>
  );
};

export default AuthorInfo;
